// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'calendar-plus';

export const Component = () => (
  <path d='M23.563 2.963H18.63V1.48c0-.335-.144-.479-.48-.479-.334 0-.478.144-.478.479v1.484H6.848V1.48c0-.335-.143-.479-.478-.479-.336 0-.48.144-.48.479v1.484H.959a.946.946 0 0 0-.67.288.946.946 0 0 0-.288.67v19.636c0 .24.096.479.287.67a.946.946 0 0 0 .67.288h22.606a.94.94 0 0 0 .67-.288.946.946 0 0 0 .288-.67V3.921a.946.946 0 0 0-.287-.67.946.946 0 0 0-.67-.288h-.002Zm0 5.892v14.703H.956V8.855h22.605Zm0-4.933v3.927H.956V3.922h22.605ZM8.812 16.182c0-.335.191-.479.526-.479h2.442v-2.442c0-.335.144-.479.48-.479.335 0 .478.144.478.479v2.442h2.442c.336 0 .527.144.527.479 0 .335-.191.527-.527.527h-2.442v2.442c0 .335-.143.479-.479.479-.335 0-.479-.144-.479-.48v-2.44H9.338c-.335 0-.526-.192-.526-.527Z' />
);

export const viewBox = '0 0 25 25';
